module.exports = __webpack_public_path__ + "img/approval-4.497fe28b.png";